import React from "react";

// Official EazyBot logo assets (stored in /public)
export default function Logo({ variant = "full", className = "", height }) {
  if (variant === "helmet") {
    return (
      <img
        src="/eazybot-helmet.png"
        alt="EazyBot"
        className={className}
        style={{ height: height || 44, width: "auto", display: "block" }}
      />
    );
  }
  return (
    <img
      src="/eazybot-wordmark.webp"
      alt="EazyBot"
      className={`select-none ${className}`}
      style={{ height: height || 40, width: "auto", display: "block" }}
    />
  );
}
